import icons from '../../shared/config/custom-icons.config';
import { useContext } from 'react';
import { ThemeContext } from '../../shared/contexts/Theme.context';

export default function CustomIcon({ type, parentColor = false, color, size = '25' }) {
  const { state: theme } = useContext(ThemeContext);
  return (
    <>
      <span className={`icon icon-${getIcon()}`}></span>
      <style jsx>{`
        .icon {
          color: ${parentColor ? 'inherit' : color ? color : theme.mainColor};
          font-size: ${size}px;
        }
      `}</style>
    </>
  );

  function getIcon() {
    if (icons[type]) return icons[type];
    else {
      return icons.default;
    }
  }
}
